import { render, staticRenderFns } from "./bundle-card-item.vue?vue&type=template&id=1039613a"
import script from "./bundle-card-item.vue?vue&type=script&lang=ts"
export * from "./bundle-card-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports